import styled from 'styled-components';
import { fontSize } from 'app/shared/styles/_fontsize';
import { padding } from 'app/shared/styles/_spacing';
import { colors } from 'app/shared/styles/_colors';
import { zindex } from 'app/shared/styles/_zindex';

export const nav = styled.nav`
  display: flex;
  height: 42px;
  padding-left: 12px;
  padding-right: 16px;
  box-shadow:
    0 1px 4px 0 rgba(0, 0, 0, 0.1),
    inset 0 0 0 0 ${colors['$hpx-grey-100']};
  align-items: center;
`;

export const header = styled.header`
  position: fixed;
  background: ${colors['$hpx-white']};
  width: 100%;
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
  z-index: ${zindex['$z-index-over-overlay']};
  height: 48px;
  display: flex;
  margin: 0 8px;

  // Adds fade out gradient to right side of FilterBar on mWeb.
  &:after {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 20%;
    content: '';
    background: linear-gradient(to left, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 80%);
    pointer-events: none;
  }
`;

export const main = styled.main`
  ${padding.top._2x};
  ${padding.left._2x};
  ${padding.right._2x};
  font-size: ${fontSize['$font-size-tiny']};
  line-break: ${fontSize['$line-height-tiny']};
  margin-top: 49px;
`;

export const article = styled.article`
  ${padding.left._2x}
  ${padding.right._2x}
`;

export const SemanticDivider = styled.hr`
  position: relative;
  left: -16px;
  width: calc(100% + 32px);
  border: none;
  margin-top: 20px;
  margin-bottom: 20px;
  clear: both;
  border-bottom: 4px solid ${colors['$hpx-grey-100']};
`;
